import React from 'react';

/**
 * @type {import('@chakra-ui/theme').ChakraTheme} theme
 */
const theme = {
  Button: {
    baseStyle: {
      borderRadius: 'button',
      _focus: {
        boxShadow: 'none',
      },
      _hover: {
        _disabled: {
          bgColor: 'disabled.base',
        },
      },
      _disabled: {
        opacity: 1,
        cursor: 'not-allowed',
        boxShadow: 'none',
        bgColor: 'disabled.base',
        color: 'gray.750',
      },
    },
    sizes: {
      md: {
        h: 9,
        minW: 8,
        fontSize: 'md',
        lineHeight: 'md',
        px: 5,
      },
    },
    // "link" | "outline" | "solid" | "ghost" | "unstyled" (chakra variants)
    variants: {
      solid: {
        bgColor: 'primary.base',
        color: 'white',
        _hover: {
          bgColor: 'primary.light',
        },
        _active: {
          bgColor: 'primary.dark',
        },
      },
      outline: {
        border: 'medium',
        bgColor: 'white',
        borderColor: 'border.base',
        _hover: {
          bgColor: 'white',
          borderColor: 'primary.base',
          color: 'primary.base',
        },
        _active: {
          bgColor: 'white',
          borderColor: 'primary.dark',
          color: 'primary.dark',
        },
      },
      social: {
        border: 'light',
        borderRadius: '4',
        fontSize: 'smPlus',
        padding: '0',
        color: 'subtleGray',
        fontWeight: 500,
        bgColor: 'white',
        lineHeight: 'normal',
        borderColor: 'border.gray',
        _hover: {
          bgColor: 'secondary.light',
        },
        _active: {
          borderColor: 'secondary.tint',
        },
      },
      primaryIcon: {
        border: 'light',
        borderRadius: '4',
        fontSize: 'smPlus',
        padding: '0',
        color: 'white',
        fontWeight: 500,
        bgColor: 'primary.base',
        lineHeight: 'normal',
        borderColor: 'primary.base',
        _hover: {
          bgColor: 'primary.light',
          borderColor: 'primary.light',
        },
        _active: {
          bgColor: 'primary.dark',
          borderColor: 'primary.dark',
        },
      },
      // Old needs to be removed
      outlineGray: {
        border: 'medium',
        bgColor: 'border.light',
        borderColor: 'border.base',
        _hover: {
          bgColor: 'border.base',
          color: 'white',
        },
      },
      outlineRound: {
        border: 'medium',
        isRound: true,
        bgColor: 'white',
        borderColor: 'primary.base',
        _hover: {
          bgColor: 'primary.base',
          color: 'white',
        },
      },
      outlinePrimaryRound: {
        border: 'medium',
        isRound: true,
        bgColor: 'white',
        borderColor: 'primary.base',
        _hover: {
          bgColor: 'white',
          borderColor: 'primary.light',
        },
        _active: {
          bgColor: 'white',
          borderColor: 'primary.dark',
        },
      },
      primaryOutline: {
        border: 'medium',
        borderColor: 'primary.base',
        _hover: {
          borderColor: 'primary.light',
        },
        _active: {
          borderColor: 'primary.dark',
        },
      },
      primary: {
        border: 'medium',
        bgColor: 'primary.base',
        borderColor: 'primary.base',
        color: 'white',
        _hover: {
          bgColor: 'primary.light',
          borderColor: 'primary.light',
        },
        _active: {
          bgColor: 'primary.dark',
          borderColor: 'primary.dark',
        },
      },
      secondaryOutlineGray: {
        border: 'medium',
        borderColor: 'border.base',
        _hover: {
          borderColor: 'secondaryButton.hover',
        },
        _active: {
          borderColor: 'secondaryButton.down',
        },
      },
      link: {
        color: 'primary.base',
        _hover: {
          textDecoration: 'none',
        },
      },
      ghost: {
        color: 'primary.base',
        _hover: {
          bgColor: 'primary.light',
          color: 'white',
        },
      },
    },
  },
};

export default theme;
